import React, { useState, useEffect,useRef } from 'react';
import { 
  Table, 
  Button, 
  Drawer, 
  Form, 
  Input, 
  Select, 
  DatePicker, 
  message, 
  Space, 
  Tooltip,
  Tag,
  Timeline,
  Spin,
  InputNumber,
  Modal,
  Divider,
  Typography,
  Badge,
  Upload
} from 'antd';
import { 
  PlusOutlined, 
  EditOutlined, 
  DeleteOutlined, 
  CommentOutlined,
  EyeOutlined,
  SearchOutlined,
  InfoCircleOutlined,
  HistoryOutlined,
  FileTextOutlined,
  LoadingOutlined,
  ShoppingCartOutlined,
  ReloadOutlined,
  TransactionOutlined,
  WhatsAppOutlined,
  CheckOutlined,
  StarFilled,
  ClockCircleTwoTone,
  FastForwardOutlined,
  MinusCircleOutlined,
  InboxOutlined,
  UploadOutlined,
  FileOutlined
} from '@ant-design/icons';
import axios from 'axios';
import dayjs from 'dayjs';
import constants from '../../constant';
import { useAuth } from '../../context/authContext';
import { useNavigate } from 'react-router-dom';

const { Option } = Select;
const { TextArea } = Input;
const { Text } = Typography;

// Lead Type Color Mapping remains the same
const LEAD_TYPE_COLORS = {
  'NOT_ANSWERED': 'gray',
  'FOLLOW_UP': 'blue',
  'MAJOR_PROSPECT': 'green',
  'FUTURE_PROSPECTS': 'cyan',
  'CLOSED': 'purple',
  'CLOSED_RNR': 'red',
  'CLOSED_LOST': 'volcano',
  'RNR_OPEN': 'orange',
  'DUPLICATE': 'magenta',
  'IRRELEVANT': 'default'
};

const LeadManagement = () => {
  const [isEditing, setEditing] = useState();
  const [showAdmin, setShowAdmin] = useState(false);
  const [viewType, setViewType] = useState();
  const [bucket,setBucket] = useState(0)
  const { RangePicker } = DatePicker;
  //order
  const navigate = useNavigate()
  const [isConversionModalOpen, setIsConversionModalOpen] = useState(false);
  const [isperformaModalOpen, setIsPerfomaModalOpen] = useState(false);
  const [isTransferOpen, setIsTransferModalOpen] = useState(false);
  const [conversionForm] = Form.useForm();
  const [performaModel] = Form.useForm();
  const [transferForm] = Form.useForm();
  const [isSubmittingOrder, setIsSubmittingOrder] = useState(false);
  // Existing state declarations
  const [leads, setLeads] = useState([]);
  const [products, setProducts] = useState([]);
  const [source, setSource] = useState([]);
  const [followUp, setFollowUp] = useState([]);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [currentLead, setCurrentLead] = useState(null);
  const [about, setAbout] = useState('');
  const [secondaryPhone, setSecondaryPhone] = useState('');
  const [otherProducts, setOtherProducts] = useState();
  const [improvement, setImprovement] = useState('');
  const [form] = Form.useForm();
  const [systemUsers, setSystemUsers] = useState([]);
  const [newComment, setNewComment] = useState('');
  const [activeTab, setActiveTab] = useState('details');
  const {currentUser, roles} = useAuth();
  const isAdmin = roles.includes('ADMIN');
  const [activity, setActivity] = useState(false);
  const [hideSave,setHideSave] = useState(false)

  // New loading states
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoadingUsers, setIsLoadingUsers] = useState(false);
  const [isLoadingProducts, setIsLoadingProducts] = useState(false);

  

  // Table params state
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 100,
      position: ["bottomCenter"],
    },
    filters: {},
  });

  const searchInput = useRef(null);

  // Enhanced fetchLeads with loading state
  const fetchLeads = async () => {
    setIsLoading(true);
    try {
      let query = [];
      let check = false
      Object.keys(tableParams.filters).forEach((k) => {
        if (tableParams.filters[k] !== null && tableParams.filters[k].length > 0) {
          if(k==="leadType") check=true

          if (k === "name") {
            query.push(`${k}:sw=${tableParams.filters[k]}`);
          }else if (k === "city") {
            query.push(`${k}:sw=${tableParams.filters[k]}`);
          } else if (k === 'nextFollowUp') {
            // query.push(`nextFollowUp:gte=${new Date(tableParams.filters[k][0]).toISOString()}&nextFollowUp:lt=${new Date(tableParams.filters[k][1]).toISOString()}`);
            let sd = new Date(tableParams.filters[k][0]);
            console.log(sd);
            
            sd.setHours(0, 0, 0, 0);
            let ed = new Date(tableParams.filters[k][0]);
            ed.setDate(ed.getDate() + 1);
            ed.setHours(0, 0, 0, 0);
    
            let sdISO = sd.toISOString();
            let edISO = ed.toISOString();
    
            query.push(`nextFollowUp:gte=${sdISO}&nextFollowUp:lt=${edISO}`);

          }else if (k === 'createdAt') {
            query.push(`createdAt:gte=${new Date(tableParams.filters[k][0]).toISOString()}&createdAt:lt=${new Date(tableParams.filters[k][1]).toISOString()}`);
          }else if(k==='productId'){
            let find =''
            tableParams.filters[k]?.map(d=>{
              find = find + d + '-'
            })
            query.push(`productId:in=${find}`);
          } else {
            query.push(`${k}=${tableParams.filters[k]}`);
          }
        }
      });
      
      if (viewType === 'FOLLOWUP') {
        let sd = new Date();
        sd.setHours(0, 0, 0, 0);
        let ed = new Date();
        ed.setDate(ed.getDate() + 1);
        ed.setHours(0, 0, 0, 0);

        let sdISO = sd.toISOString();
        let edISO = ed.toISOString();

        query.push(`nextFollowUp:gte=${sdISO}&nextFollowUp:lt=${edISO}`);
      }

      if (viewType === 'OLDER') {
        let sd = new Date();
        sd.setHours(0, 0, 0, 0);
        let ed = new Date();
        ed.setDate(ed.getDate() + 1);
        ed.setHours(0, 0, 0, 0);

        let sdISO = sd.toISOString();
        let edISO = ed.toISOString();

        query.push(`nextFollowUp:lt=${sdISO}`);
      }

      if(bucket === 0 && !check){
        query.push(`leadType:in=NOT_ANSWERED&transferredPOC:eq=null`);
      }
      if(bucket === 7 && !check){
        query.push(`leadType:in=NOT_ENQUIRED&transferredPOC:eq=null`);
      }
      if(bucket === 1 && !check){
        query.push(`leadType:in=SAMPLE_KIT&transferredPOC:eq=null`);
      }
      if(bucket === 2 && !check){
        query.push(`leadType:in=FOLLOW_UP-MAJOR_PROSPECT&transferredPOC:eq=null`);
      }
      if(bucket === 8 && !check){
        query.push(`leadType:in=FUTURE_PROSPECTS-RNR_OPEN`);
      }
      if(bucket === 3){ // by You
        query.push(`transferredFirebaseId=${currentUser._delegate.uid}&transfer=BY`);
      }
      if(bucket === 6){ // for You
        query.push(`transferredFirebaseId=${currentUser._delegate.uid}&transfer=FOR`);
      }
      if(bucket === 4 && !check){
        query.push(`leadType:in=CLOSED-CLOSED_RNR-CLOSED_LOST-DUPLICATE-IRRELEVANT&transferredPOC:eq=null`);
      }
      if(bucket === 5 && !check){
        query.push(`leadType:in=ORDER_CONFIRMED&transferredPOC:eq=null`);
      }

      
      query = `showAdmin=${showAdmin}&page=${tableParams.pagination.current}&limit=${tableParams.pagination.pageSize}&firebaseId=${currentUser._delegate.uid}&${query.join("&")}`;
      const response = await axios.get(`${constants.DOMAIN}/api/v1/marketing/getMarketingData?${query}`);
      setLeads(response.data.data.users);
      setTableParams({
        ...tableParams,
        pagination: {
          ...tableParams.pagination,
          total: response.data.results,
        },
      })
    } catch (error) {
      message.error('Failed to fetch leads');
    } finally {
      setIsLoading(false);
    }
  };
  
  console.log(tableParams);
  

  // Enhanced fetchSystemUsers with loading state
  const fetchSystemUsers = async () => {
    setIsLoadingUsers(true);
    try {
      const response = await axios.get(`${constants.DOMAIN}/api/v1/systemuser/getUser`);
      setSystemUsers(response.data.data.users);
    } catch (error) {
      message.error('Failed to fetch system users');
    } finally {
      setIsLoadingUsers(false);
    }
  };

  const fetchActivity = async (id) => {
    setIsLoadingUsers(true);
    setActivity([])
    try {
      const response = await axios.get(`${constants.DOMAIN}/api/v1/marketing/activity/${id}`);
      setActivity(response.data.data);
    } catch (error) {
      message.error('Failed to fetch system users');
    } finally {
      setIsLoadingUsers(false);
    }
  };

  // Enhanced fetchProducts with loading state
  const fetchProducts = async () => {
    setIsLoadingProducts(true);
    try {
      let query = [];
      Object.keys(tableParams.filters).forEach((k) => {
        if (tableParams.filters[k]?.length > 0) {
          query.push(`${k}:sw=${tableParams.filters[k]}`);
        }
      });

      const res = await axios.get(`${constants.DOMAIN}/api/v1/products/?${query.join("&")}`);
      setProducts(res.data.data.products);
    } catch (error) {
      message.error('Failed to load products');
    } finally {
      setIsLoadingProducts(false);
    }
  };

  const fetchSource = async () => {
    setIsLoadingProducts(true);
    try {
      const res = await axios.get(`${constants.DOMAIN}/api/v1/marketing/source`);
      setSource(res.data.data);
    } catch (error) {
      message.error('Failed to load products');
    } finally {
      setIsLoadingProducts(false);
    }
  };


  const fetchFllowup = async () => {
    setIsLoadingProducts(true);
    try {
      const res = await axios.get(`${constants.DOMAIN}/api/v1/marketing/followUp`);
      setFollowUp(res.data.data);
    } catch (error) {
      message.error('Failed to load products');
    } finally {
      setIsLoadingProducts(false);
    }
  };

  //order
  const handleOrderSubmit = async (values) => {
    setIsSubmittingOrder(true);
    console.log(values);
    
    try {
      await axios.post(`${constants.DOMAIN}/api/v1/marketing/createOrder_v1/new`, values);
      message.success('Order created successfully');
      setIsConversionModalOpen(false);
      conversionForm.resetFields();
      fetchLeads();
    } catch (error) {
      message.error('Failed to create order');
    } finally {
      setIsSubmittingOrder(false);
    }
  };


  const ConversionModal = () => {
    // State for tracking uploaded files
    const [error, setError] = useState("");
    const [files, setFiles] = useState([]);
  
    const handleFileChange = (event) => {
      const selectedFiles = Array.from(event.target.files);
      setFiles((prevFiles) => [...prevFiles, ...selectedFiles]);
    };
  
    const removeFile = (index) => {
      setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    };
  
    const handleUpload = async () => {
      const uploadedUrls = [];
      const maxSize = 1024 * 1024 * 10; // 10MB limit
    
      if (!files.length) {
        return [];
      }
    
      // Validate file sizes
      for (let file of files) {
        if (file.size > maxSize) {
          return setError(`File "${file.name}" is larger than 10MB`);
        }
      }
    
      try {
        const uploadPromises = files.map(async (file) => {
          const formData = new FormData();
          formData.append("file", file);
          formData.append("upload_preset", "wdqav8pw");
          formData.append("public_id", `${currentLead?._id}-${Date.now()}`);
          formData.append("folder", "assets");
    
          const res = await axios.post(
            "https://api.cloudinary.com/v1_1/drb2pi1dv/raw/upload/",
            formData
          );
    
          return res.data.url + "?publicId=" + res.data.public_id + "&name=" + file.name;
        });
    
        // Wait for all uploads to finish
        const results = await Promise.all(uploadPromises);
        uploadedUrls.push(...results);
    
        return uploadedUrls;
      } catch (err) {
        console.error("Upload error:", err);
        setError("Something Went Wrong: " + (err.response?.data?.error?.message || err.message));
        return [];
      }
    };
    
    // Function to calculate totals based on products and charges
    const calculateTotals = () => {
      try {
        const products = conversionForm.getFieldValue('products') || [];
        const additionalCharges = conversionForm.getFieldValue('additionalCharges') || 0;
        const packagingCharges = conversionForm.getFieldValue('packagingCharges') || 0;
        
        // Calculate products subtotal with individual GST
        let productsTotal = 0;
        let totalGSTAmount = 0;
        
        products.forEach(product => {
          if (product && product.quantity && product.rate) {
            const productSubtotal = product.quantity * product.rate;
            // Calculate individual product GST based on its own percentage
            const productGSTPercentage = product.gstPercentage || 0;
            const productGST = productSubtotal * (parseFloat(productGSTPercentage) / 100);
            totalGSTAmount += productGST;
            productsTotal += productSubtotal;
          }
        });
        
        // Calculate total without GST
        const totalWithoutGST = productsTotal + additionalCharges + packagingCharges;
        conversionForm.setFieldsValue({ totalWithoutGST });
        
        // Calculate GST on additional and packaging charges
        const defaultGSTPercentage = conversionForm.getFieldValue('defaultGSTPercentage') || 0;
        const additionalGST = additionalCharges * (parseFloat(defaultGSTPercentage) / 100);
        const packagingGST = packagingCharges * (parseFloat(defaultGSTPercentage) / 100);
        totalGSTAmount += additionalGST + packagingGST;
        
        // Calculate total with GST
        const totalWithGST = totalWithoutGST + totalGSTAmount;
        conversionForm.setFieldsValue({ totalWithGST, totalGSTAmount });
      } catch (error) {
        console.error("Error calculating totals:", error);
      }
    };
  
    return (
      <Modal
        title="Create Order"
        open={isConversionModalOpen}
        onCancel={() => {
          setIsConversionModalOpen(false);
          conversionForm.resetFields();
        }}
        footer={null}
        width={800}
      >
        <Form
          form={conversionForm}
          layout="vertical"
          onValuesChange={(changedValues, allValues) => {
            // Recalculate totals whenever form values change
            calculateTotals();
          }}
          onFinish={async (values) => {
            // Upload files and get URLs
            const fileUrls = await handleUpload();
            if(typeof(fileUrls) === "string"){
              return;
            }
            // Add file URLs to form values
            const updatedValues = {
              ...values,
              fileUrls,
              leadId: currentLead._id,
            };
            console.log(updatedValues);
            
            // Submit the form with updated values
            handleOrderSubmit(updatedValues);
          }}
        >
          <div className="grid grid-cols-2 gap-4">
            <Form.Item
              name="name"
              label="Name"
              rules={[{ required: true, message: 'Please enter name' }]}
            >
              <Input
                className="w-full"
                placeholder="Enter Name"
              />
            </Form.Item>
            <Form.Item
              name="primaryPhone"
              label="Primary Phone"
              rules={[
                { required: true, message: 'Please enter phone number' },
                { pattern: /^[0-9]{10}$/, message: 'Please enter valid phone number' }
              ]}
            >
              <Input placeholder="Enter phone number" />
            </Form.Item>
            <Form.Item
              name="city"
              label="City"
              rules={[{ required: true, message: 'Please enter city' }]}
            >
              <Input
                className="w-full"
                placeholder="Enter City"
              />
            </Form.Item>
            <Form.Item
              name="poc"
              label="Point of Contact"
              rules={[{ required: true, message: 'Please select POC' }]}
            >
              <Select placeholder="Select POC">
                {systemUsers.map(user => (
                  <Option key={user._id} value={user._id}>
                    {user.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="pincode"
              label="Pincode"
            >
              <InputNumber
                className="w-full"
                placeholder="Enter pincode"
                min={100000}
                max={999999}
              />
            </Form.Item>
  
            <Form.Item
              name="flat"
              label="Flat/House No."
            >
              <Input placeholder="Enter flat/house no." />
            </Form.Item>
  
            <Form.Item
              name="area"
              label="Area/Street"
            >
              <Input placeholder="Enter area/street" />
            </Form.Item>
  
            <Form.Item
              name="state"
              label="State"
            >
              <Input placeholder="Enter state" />
            </Form.Item>
          </div>
  
          {/* Order Priority and Dispatch Date */}
          <div className="grid grid-cols-2 gap-4 mt-4 mb-4 bg-[ghostwhite] p-6 rounded-lg border border-gray-300">
            <Form.Item
              name="orderPriority"
              label="Order Priority"
              rules={[{ required: true, message: 'Please select priority' }]}
            >
              <Select placeholder="Select Priority">
                <Option value="HIGH">High</Option>
                <Option value="MEDIUM">Medium</Option>
                <Option value="LOW">Low</Option>
              </Select>
            </Form.Item>
            <Form.Item
              name="dispatchDate"
              label="Expected Dispatch Date"
              rules={[{ required: true, message: 'Please select dispatch date' }]}
            >
              <DatePicker className="w-full" />
            </Form.Item>
          </div>
  
          {/* Products Section */}        
          <div className='bg-[ghostwhite] p-6 pb-[10px]'>
            <Form.List name="products">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }, i) => (
                    <div key={i} className="mb-6 border-b pb-4">
                      <h1 style={{ textAlign: "center", fontSize: "14px" }}>
                        Product {i + 1}
                        <span>
                          <MinusCircleOutlined
                            style={{ color: "red", marginLeft: "20px" }}
                            onClick={() => {
                              remove(name);
                              // Recalculate after removing a product
                              setTimeout(calculateTotals, 0);
                            }}
                          />
                        </span>
                      </h1>
                      <div className='flex gap-3 justify-center items-center mt-2'>
                        <Form.Item
                          {...restField}
                          name={[name, "productCode"]}
                          label="Product Code"
                          rules={[{ required: true, message: 'Please select product' }]}
                        >
                          <Select placeholder="Select product" allowClear>
                            {products.map(product => (
                              <Option key={product.code} value={product.code}>
                                {product.name} ({product.code})
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, "productName"]}
                          label="Product Name"
                          rules={[{ required: true, message: 'Please enter product name' }]}
                        >
                          <Input
                            className="w-full"
                            placeholder="Enter product name"
                          />
                        </Form.Item>
                      </div>
                      <div className='flex gap-3 justify-center items-center mt-2'>
                        <Form.Item
                          {...restField}
                          name={[name, "quantity"]}
                          label="Quantity"
                          rules={[{ required: true, message: 'Please enter quantity' }]}
                        >
                          <InputNumber
                            className="w-full"
                            placeholder="Enter quantity"
                            min={1}
                          />
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, "rate"]}
                          label="Rate"
                          rules={[{ required: true, message: 'Please enter Rate' }]}
                        >
                          <InputNumber
                            className="w-full"
                            placeholder="Enter amount"
                            min={0}
                          />
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, "size"]}
                          label="Size"
                          rules={[{ required: true, message: 'Please enter size' }]}
                        >
                          <Input
                            className="w-full"
                            placeholder="Enter size (e.g., 10x12, M, 36EU)"
                          />
                        </Form.Item>
                      </div>
                      <div className='flex gap-3 justify-center items-center mt-2'>
                        <Form.Item
                          {...restField}
                          name={[name, "gstPercentage"]}
                          label="GST %"
                          rules={[{ required: true, message: 'Please select GST percentage' }]}
                        >
                          <Select placeholder="Select GST">
                            <Option value="18">18 %</Option>
                            <Option value="12">12 %</Option>
                            <Option value="5">5 %</Option>
                            <Option value="0">0 %</Option>
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  ))}
                  <Form.Item
                    wrapperCol={{
                      span: 20,
                    }}
                    style={{ backgroundColor: "ghostwhite", display: "flex", justifyContent: "center" }}
                  >
                    <Button
                      className='w-max'
                      onClick={() => add()}
                      block
                      icon={<PlusOutlined />}
                    >
                      Add Product
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form.List>
          </div>
          
          {/* Financial Details Section */}
          <div className="bg-blue-50 p-6 rounded-lg border border-blue-200 mt-4">
            <h3 className="text-lg font-semibold mb-4 text-blue-800">💰 Financial Details</h3>
            <div className="grid grid-cols-3 gap-4">
              <Form.Item
                name="additionalCharges"
                label="Additional Charges"
              >
                <InputNumber
                  className="w-full"
                  placeholder="Enter amount"
                  min={0}
                />
              </Form.Item>
              <Form.Item
                name="packagingCharges"
                label="Packaging Charges"
              >
                <InputNumber
                  className="w-full"
                  placeholder="Enter amount"
                  min={0}
                />
              </Form.Item>
              <Form.Item
                name="defaultGSTPercentage"
                label="GST % (for Additional/Packaging)"
                rules={[{ required: true, message: 'Please select GST percentage' }]}
              >
                <Select placeholder="Select GST %">
                  <Option value="18">18%</Option>
                  <Option value="12">12%</Option>
                  <Option value="5">5%</Option>
                  <Option value="0">0%</Option>
                </Select>
              </Form.Item>
            </div>
            
            {/* Amount Summary */}
            <div className="grid grid-cols-2 gap-4 mt-4 bg-white p-4 rounded border">
              <Form.Item
                name="totalWithoutGST"
                label="Amount (Excluding GST)"
                rules={[{ required: true, message: 'Please enter amount' }]}
              >
                <InputNumber
                  className="w-full"
                  placeholder="Auto-calculated"
                  min={0}
                  disabled
                  style={{ backgroundColor: '#f5f5f5' }}
                />
              </Form.Item>
              <Form.Item
                name="totalGSTAmount"
                label="Total GST Amount"
              >
                <InputNumber
                  className="w-full"
                  placeholder="Auto-calculated"
                  min={0}
                  disabled
                  style={{ backgroundColor: '#f5f5f5' }}
                />
              </Form.Item>
              <Form.Item
                name="totalWithGST"
                label="Amount (Including GST)"
                rules={[{ required: true, message: 'Please enter amount' }]}
              >
                <InputNumber
                  className="w-full"
                  placeholder="Auto-calculated"
                  min={0}
                  disabled
                  style={{ backgroundColor: '#f0f9ff', fontWeight: 'bold' }}
                />
              </Form.Item>
              <Form.Item
                name="advanceAmount"
                label="Advance Amount"
                rules={[{ required: true, message: 'Please enter amount' }]}
              >
                <InputNumber
                  className="w-full"
                  placeholder="Enter advance amount"
                  min={0}
                />
              </Form.Item>
            </div>
          </div>

          {/* Dispatch & Order Details */}
          <div className="bg-green-50 p-6 rounded-lg border border-green-200 mt-4">
            <h3 className="text-lg font-semibold mb-4 text-green-800">🚚 Dispatch & Order Details</h3>
            <div className="grid grid-cols-2 gap-4">
              <Form.Item
                name="dispatch"
                label="Dispatch Mode"
                rules={[{ required: true, message: 'Please select dispatch mode' }]}
              >
                <Select placeholder="Select Mode">
                  <Option value="BUS">Bus</Option>
                  <Option value="TRAIN">Train</Option>
                  <Option value="FLIGHT">Flight</Option>
                  <Option value="COURIER">Courier</Option>
                  <Option value="SELF">Self</Option>
                </Select>
              </Form.Item>
              <Form.Item
                name="orderThrough"
                label="Order Through"
                rules={[{ required: true, message: 'Please enter order through' }]}
              >
                <Input
                  className="w-full"
                  placeholder="Enter order source (e.g., Phone, WhatsApp, Email, etc.)"
                />
              </Form.Item>
              <Form.Item
                name="gstNumber"
                label="GST Number"
              >
                <Input
                  className="w-full"
                  placeholder="Enter GST Number"
                />
              </Form.Item>
            </div>
          </div>

          <div className="mt-4 mb-4 bg-[ghostwhite] p-6 rounded-lg border border-gray-300">
            <Form.Item name="comments" label="Comments">
              <TextArea 
                rows={4} 
                placeholder="Add a comment..."
              />
            </Form.Item>
            <div className="mt-4 mb-4 bg-[ghostwhite] p-6 rounded-lg border border-gray-300">
            <h3 className="mb-3 text-lg font-semibold">Upload Files</h3>
            <label className="block w-full cursor-pointer border-dashed border-2 border-gray-400 p-4 rounded-lg text-center bg-white hover:bg-gray-100 transition">
              <input
                type="file"
                multiple
                className="hidden"
                onChange={handleFileChange}
              />
              <UploadOutlined className="text-2xl text-gray-600 mb-2" />
              <p className="text-gray-700">Click to select files</p>
              <p className="text-sm text-gray-500">Supports multiple file uploads</p>
            </label>
  
            {files.length > 0 && (
              <ul className="mt-4 space-y-2">
                {files.map((file, index) => (
                  <li
                    key={index}
                    className="flex items-center justify-between bg-white p-2 rounded-lg shadow-sm border border-gray-200"
                  >
                    <span className="text-gray-800 text-sm truncate">{file.name}</span>
                    <button onClick={() => removeFile(index)}>
                      <DeleteOutlined className="text-red-500 text-lg hover:text-red-700 transition" />
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </div>
          </div>
  
          <Form.Item className="mb-0">
            <Space className="w-full justify-end">
              <Button onClick={() => setIsConversionModalOpen(false)}>
                Cancel
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                icon={<ShoppingCartOutlined />}
                loading={isSubmittingOrder}
              >
                Create Order
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    );
  };

  const PerfomaModel = () => {
    // State for tracking uploaded files
    const [error, setError] = useState("");
    const [files, setFiles] = useState([]);
  
    const handleFileChange = (event) => {
      const selectedFiles = Array.from(event.target.files);
      setFiles((prevFiles) => [...prevFiles, ...selectedFiles]);
    };
  
    const removeFile = (index) => {
      setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    };
  
    const handleUpload = async () => {
      const uploadedUrls = [];
      const maxSize = 1024 * 1024 * 10; // 10MB limit
    
      if (!files.length) {
        return [];
      }
    
      // Validate file sizes
      for (let file of files) {
        if (file.size > maxSize) {
          return setError(`File "${file.name}" is larger than 10MB`);
        }
      }
    
      try {
        const uploadPromises = files.map(async (file) => {
          const formData = new FormData();
          formData.append("file", file);
          formData.append("upload_preset", "wdqav8pw");
          formData.append("public_id", `${currentLead?._id}-${Date.now()}`);
          formData.append("folder", "assets");
    
          const res = await axios.post(
            "https://api.cloudinary.com/v1_1/drb2pi1dv/raw/upload/",
            formData
          );
    
          return res.data.url + "?publicId=" + res.data.public_id + "&name=" + file.name;
        });
    
        // Wait for all uploads to finish
        const results = await Promise.all(uploadPromises);
        uploadedUrls.push(...results);
    
        return uploadedUrls;
      } catch (err) {
        console.error("Upload error:", err);
        setError("Something Went Wrong: " + (err.response?.data?.error?.message || err.message));
        return [];
      }
    };
    
    // Function to calculate totals based on products and charges
    const calculateTotals = () => {
      try {
        const products = performaModel.getFieldValue('products') || [];
        const additionalCharges = performaModel.getFieldValue('additionalCharges') || 0;
        const packagingCharges = performaModel.getFieldValue('packagingCharges') || 0;
        
        // Calculate products subtotal with individual GST
        let productsTotal = 0;
        let totalGSTAmount = 0;
        
        products.forEach(product => {
          if (product && product.quantity && product.rate) {
            const productSubtotal = product.quantity * product.rate;
            // Calculate individual product GST based on its own percentage
            const productGSTPercentage = product.gstPercentage || 0;
            const productGST = productSubtotal * (parseFloat(productGSTPercentage) / 100);
            totalGSTAmount += productGST;
            productsTotal += productSubtotal;
          }
        });
        
        // Calculate total without GST
        const totalWithoutGST = productsTotal + additionalCharges + packagingCharges;
        performaModel.setFieldsValue({ totalWithoutGST });
        
        // Calculate GST on additional and packaging charges
        const defaultGSTPercentage = performaModel.getFieldValue('defaultGSTPercentage') || 0;
        const additionalGST = additionalCharges * (parseFloat(defaultGSTPercentage) / 100);
        const packagingGST = packagingCharges * (parseFloat(defaultGSTPercentage) / 100);
        totalGSTAmount += additionalGST + packagingGST;
        
        // Calculate total with GST
        const totalWithGST = totalWithoutGST + totalGSTAmount;
        performaModel.setFieldsValue({ totalWithGST, totalGSTAmount });
      } catch (error) {
        console.error("Error calculating totals:", error);
      }
    };
  
    return (
      <Modal
        title="Create Proforma Invoice"
        open={isperformaModalOpen}
        onCancel={() => {
          setIsPerfomaModalOpen(false);
          performaModel.resetFields();
        }}
        footer={null}
        width={800}
      >
        <Form
          form={performaModel}
          layout="vertical"
          onValuesChange={(changedValues, allValues) => {
            // Recalculate totals whenever form values change
            calculateTotals();
          }}
          onFinish={async (values) => {
            localStorage.setItem("invoice",JSON.stringify(values))
            navigate(`/invoice?data=${JSON.stringify(values)}`)
          }}
        >
          <div className="grid grid-cols-2 gap-4">
            <Form.Item
              name="name"
              label="Name"
              rules={[{ required: true, message: 'Please enter name' }]}
            >
              <Input
                className="w-full"
                placeholder="Enter Name"
              />
            </Form.Item>
            <Form.Item
              name="primaryPhone"
              label="Primary Phone"
              rules={[
                { required: true, message: 'Please enter phone number' },
                { pattern: /^[0-9]{10}$/, message: 'Please enter valid phone number' }
              ]}
            >
              <Input placeholder="Enter phone number" />
            </Form.Item>
            <Form.Item
              name="city"
              label="City"
              rules={[{ required: true, message: 'Please enter city' }]}
            >
              <Input
                className="w-full"
                placeholder="Enter City"
              />
            </Form.Item>
            <Form.Item
              name="poc"
              label="Point of Contact"
              rules={[{ required: true, message: 'Please select POC' }]}
            >
              <Select placeholder="Select POC">
                {systemUsers.map(user => (
                  <Option key={user._id} value={user._id}>
                    {user.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="pincode"
              label="Pincode"
            >
              <InputNumber
                className="w-full"
                placeholder="Enter pincode"
                min={100000}
                max={999999}
              />
            </Form.Item>
  
            <Form.Item
              name="flat"
              label="Flat/House No."
            >
              <Input placeholder="Enter flat/house no." />
            </Form.Item>
  
            <Form.Item
              name="area"
              label="Area/Street"
            >
              <Input placeholder="Enter area/street" />
            </Form.Item>
  
            <Form.Item
              name="state"
              label="State"
            >
              <Input placeholder="Enter state" />
            </Form.Item>
          </div>
  
          {/* Products Section */}        
          <div className='bg-[ghostwhite] p-6 pb-[10px]'>
            <Form.List name="products">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }, i) => (
                    <div key={i} className="mb-6 border-b pb-4">
                      <h1 style={{ textAlign: "center", fontSize: "14px" }}>
                        Product {i + 1}
                        <span>
                          <MinusCircleOutlined
                            style={{ color: "red", marginLeft: "20px" }}
                            onClick={() => {
                              remove(name);
                              // Recalculate after removing a product
                              setTimeout(calculateTotals, 0);
                            }}
                          />
                        </span>
                      </h1>
                      <div className='flex gap-3 justify-center items-center mt-2'>
                        <Form.Item
                          {...restField}
                          name={[name, "productCode"]}
                          label="Product Code"
                          rules={[{ required: true, message: 'Please select product' }]}
                        >
                          <Select placeholder="Select product" allowClear>
                            {products.map(product => (
                              <Option key={product.code} value={product.code}>
                                {product.name} ({product.code})
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, "productName"]}
                          label="Product Name"
                          rules={[{ required: true, message: 'Please enter product name' }]}
                        >
                          <Input
                            className="w-full"
                            placeholder="Enter product name"
                          />
                        </Form.Item>
                      </div>
                      <div className='flex gap-3 justify-center items-center mt-2'>
                        <Form.Item
                          {...restField}
                          name={[name, "quantity"]}
                          label="Quantity"
                          rules={[{ required: true, message: 'Please enter quantity' }]}
                        >
                          <InputNumber
                            className="w-full"
                            placeholder="Enter quantity"
                            min={1}
                          />
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, "rate"]}
                          label="Rate"
                          rules={[{ required: true, message: 'Please enter Rate' }]}
                        >
                          <InputNumber
                            className="w-full"
                            placeholder="Enter amount"
                            min={0}
                          />
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, "size"]}
                          label="Size"
                          rules={[{ required: true, message: 'Please enter size' }]}
                        >
                          <Input
                            className="w-full"
                            placeholder="Enter size (e.g., 10x12, M, 36EU)"
                          />
                        </Form.Item>
                      </div>
                      <div className='flex gap-3 justify-center items-center mt-2'>
                        <Form.Item
                          {...restField}
                          name={[name, "gstPercentage"]}
                          label="GST %"
                          rules={[{ required: true, message: 'Please select GST percentage' }]}
                        >
                          <Select placeholder="Select GST">
                            <Option value="18">18 %</Option>
                            <Option value="12">12 %</Option>
                            <Option value="5">5 %</Option>
                            <Option value="0">0 %</Option>
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  ))}
                  <Form.Item
                    wrapperCol={{
                      span: 20,
                    }}
                    style={{ backgroundColor: "ghostwhite", display: "flex", justifyContent: "center" }}
                  >
                    <Button
                      className='w-max'
                      onClick={() => add()}
                      block
                      icon={<PlusOutlined />}
                    >
                      Add Product
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form.List>
          </div>
          
          {/* Financial Details Section */}
          <div className="bg-blue-50 p-6 rounded-lg border border-blue-200 mt-4">
            <h3 className="text-lg font-semibold mb-4 text-blue-800">💰 Financial Details</h3>
            <div className="grid grid-cols-3 gap-4">
              <Form.Item
                name="additionalCharges"
                label="Additional Charges"
              >
                <InputNumber
                  className="w-full"
                  placeholder="Enter amount"
                  min={0}
                />
              </Form.Item>
              <Form.Item
                name="packagingCharges"
                label="Packaging Charges"
              >
                <InputNumber
                  className="w-full"
                  placeholder="Enter amount"
                  min={0}
                />
              </Form.Item>
              <Form.Item
                name="defaultGSTPercentage"
                label="GST % (for Additional/Packaging)"
                rules={[{ required: true, message: 'Please select GST percentage' }]}
              >
                <Select placeholder="Select GST %">
                  <Option value="18">18%</Option>
                  <Option value="12">12%</Option>
                  <Option value="5">5%</Option>
                  <Option value="0">0%</Option>
                </Select>
              </Form.Item>
            </div>
            
            {/* Amount Summary */}
            <div className="grid grid-cols-2 gap-4 mt-4 bg-white p-4 rounded border">
              <Form.Item
                name="totalWithoutGST"
                label="Amount (Excluding GST)"
                rules={[{ required: true, message: 'Please enter amount' }]}
              >
                <InputNumber
                  className="w-full"
                  placeholder="Auto-calculated"
                  min={0}
                  disabled
                  style={{ backgroundColor: '#f5f5f5' }}
                />
              </Form.Item>
              <Form.Item
                name="totalGSTAmount"
                label="Total GST Amount"
              >
                <InputNumber
                  className="w-full"
                  placeholder="Auto-calculated"
                  min={0}
                  disabled
                  style={{ backgroundColor: '#f5f5f5' }}
                />
              </Form.Item>
              <Form.Item
                name="totalWithGST"
                label="Amount (Including GST)"
                rules={[{ required: true, message: 'Please enter amount' }]}
              >
                <InputNumber
                  className="w-full"
                  placeholder="Auto-calculated"
                  min={0}
                  disabled
                  style={{ backgroundColor: '#f0f9ff', fontWeight: 'bold' }}
                />
              </Form.Item>
              <Form.Item
                name="advanceAmount"
                label="Advance Amount"
                rules={[{ required: true, message: 'Please enter amount' }]}
              >
                <InputNumber
                  className="w-full"
                  placeholder="Enter advance amount"
                  min={0}
                />
              </Form.Item>
            </div>
          </div>

          {/* Dispatch & Order Details */}
          <div className="bg-green-50 p-6 rounded-lg border border-green-200 mt-4">
            <h3 className="text-lg font-semibold mb-4 text-green-800">🚚 Dispatch & Order Details</h3>
            <div className="grid grid-cols-2 gap-4">
              <Form.Item
                name="dispatch"
                label="Dispatch Mode"
                rules={[{ required: true, message: 'Please select dispatch mode' }]}
              >
                <Select placeholder="Select Mode">
                  <Option value="BUS">Bus</Option>
                  <Option value="TRAIN">Train</Option>
                  <Option value="FLIGHT">Flight</Option>
                  <Option value="COURIER">Courier</Option>
                  <Option value="SELF">Self</Option>
                </Select>
              </Form.Item>
              <Form.Item
                name="orderThrough"
                label="Order Through"
                rules={[{ required: true, message: 'Please enter order through' }]}
              >
                <Input
                  className="w-full"
                  placeholder="Enter order source (e.g., Phone, WhatsApp, Email, etc.)"
                />
              </Form.Item>
              <Form.Item
                name="gstNumber"
                label="GST Number"
              >
                <Input
                  className="w-full"
                  placeholder="Enter GST Number"
                />
              </Form.Item>
            </div>
          </div>
        
  
          <Form.Item className="mb-0">
            <Space className="w-full justify-end">
              <Button onClick={() => setIsPerfomaModalOpen(false)}>
                Cancel
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                loading={isSubmittingOrder}
              >
               Generate
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    );
  };
  
  const TransferPoc = () => (
    <Modal
      title="Transfer Lead"
      open={isTransferOpen}
      onCancel={() => {
        setIsTransferModalOpen(false);
        transferForm.resetFields();
      }}
      footer={null}
      width={400}
    >
      <Form
        form={transferForm}
        layout="vertical"
        onFinish={handleTransferSubmit}
      >
        <div className="grid grid-cols-1 gap-4">
          <Form.Item
            name="transferPoc"
            label="Point of Contact"
            rules={[{ required: true, message: 'Please select POC' }]}
          >
            <Select placeholder="Select POC">
              {systemUsers.map(user => (
                <Option key={user._id} value={user._id}>
                  {user.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
 
        </div>
        
        
       
        <Form.Item className="mb-0">
          <Space className="w-full justify-end">
            <Button onClick={() => setIsTransferModalOpen(false)}>
              Cancel
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              icon={<ShoppingCartOutlined />}
              loading={isSubmittingOrder}
            >
              Transfer
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );

  // Modi

  // Enhanced handleSubmit with loading state
  const handleSubmit = async (values) => {
console.log(values);

    const today = new Date();
today.setHours(0, 0, 0, 0); // Set time to 00:00:00

const nextFollowUpDate = new Date(values.nextFollowUp); // Example date

if (nextFollowUpDate >= today || values.leadType === 'CLOSED') {

} else {
    return  message.error('Next follow-up date is before todays date or Empty');
}

if(!values.POC && !currentLead){
  const user = systemUsers.find(user => user.firebaseId === currentUser._delegate.uid);
  values.POC = user._id
}

    setIsSubmitting(true);
    try {
      const submissionValues = {
        ...values,
        nextFollowUp: values.nextFollowUp ? new Date(values.nextFollowUp).toISOString() : null,
        platform: "CRM"
      };

      await axios.post(`${constants.DOMAIN}/api/v1/marketing/createOrUpdateUser`, submissionValues);
      message.success( 'Lead updated successfully');
      fetchLeads();
      setIsDrawerOpen(false);
      setCurrentLead(null);
      setEditing(null)
    } catch (error) {
      message.error('Failed to save lead');
    } finally {
      setIsSubmitting(false);
      
    }
  };

  // Existing useEffect hooks
  useEffect(() => {
    fetchLeads();
  }, [tableParams.filters,viewType,bucket,showAdmin]);

  useEffect(() => {
    fetchSystemUsers();
    fetchSource()
    fetchFllowup()
    fetchProducts();
  }, []);

  useEffect(() => {
    if (currentLead) {
      form.setFieldsValue({
        ...currentLead,
        nextFollowUp: currentLead.nextFollowUp ? dayjs(currentLead.nextFollowUp) : null,
        POC: currentLead.POC?._id || null
      });
    } else {
      form.resetFields();
    }
  }, [currentLead, form]);

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => {
      return(
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button 
            type="primary" 
            icon={<SearchOutlined />} 
            size="small" 
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          >
            Search
          </Button>
          <Button 
            size="small" 
            onClick={() => clearFilters && handleReset(clearFilters)}
          >
            Reset
          </Button>
          <Button type="link" size="small" onClick={close}>
            Close
          </Button>
        </Space>
      </div>
    )},
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
  });

  // Handle search action
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setTableParams({
      ...tableParams,
      pagination: { ...tableParams.pagination, current: 1 },
      filters: { [dataIndex]: selectedKeys },
    });
  };

  // Reset search filters
  const handleReset = (clearFilters) => {
    clearFilters();
    fetchLeads();
  };

  const handleTableChange = (pagination, filters, sorter, extra) => {
    setTableParams({
      pagination,
      filters,
      sorter,
    })

    // `dataSource` is useless since `pageSize` changed
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setLeads([])
    }
  }

  // Handle adding a new comment
  const handleAddComment = async () => {
    if (!newComment.trim()) {
      message.warning('Comment cannot be empty');
      return;
    }

    try {
      const commentPayload = {
        date: new Date(),
        text: newComment
      };

      // If editing existing lead, update comments
      if (currentLead) {
        const updatedLead = {
          ...currentLead,
           platform : "CRM",
          comments: [...(currentLead.comments || []), commentPayload]
        };

        await axios.post(`${constants.DOMAIN}/api/v1/marketing/createOrUpdateUser`, updatedLead);
        
        // Update local state
        setCurrentLead(updatedLead);
        setLeads(leads.map(lead => 
          lead._id === currentLead._id ? updatedLead : lead
        ));
        
        // Clear comment input
        setNewComment('');
        message.success('Comment added successfully');
      } else {
        // For new lead, store comment to be saved with lead
        form.setFieldsValue({
          comments: [...(form.getFieldValue('comments') || []), commentPayload]
        });
        setNewComment('');
      }
    } catch (error) {
      message.error('Failed to add comment');
    }
  };

  const handleTransferSubmit = async (values) => {
    if (!values.transferPoc) {
      message.warning('Transfer cannot be empty');
      return;
    }

    try {
      // If editing existing lead, update comments
      if (currentLead) {
        const updatedLead = {
          ...currentLead,
          transferredPOC:values.transferPoc,
          platform : "CRM",
        };

        await axios.post(`${constants.DOMAIN}/api/v1/marketing/transfers`, updatedLead);
        
        // Update local state
        setCurrentLead(updatedLead);
        setLeads(leads.map(lead => 
          lead._id === currentLead._id ? updatedLead : lead
        ));
        
        // Clear comment input
        setNewComment('');
        message.success('Transferred successfully');
        setIsTransferModalOpen(false)
      } else {
      }
    } catch (error) {
      message.error('Request Failed 404');
    }
  };

 
  const handleWhatsAppSend = (record, secondary = false) => {
    const pdfURL = encodeURIComponent("https://asset.cloudinary.com/drb2pi1dv/97ab82b7606f915bb58cf4575f087998");

    const message = encodeURIComponent(
      `Dear ${record.name},
  
  Thank you for reaching out to Printverse Pvt Ltd. regarding your interest in ${products?.find(item => item.code === record.productId)?.name ?? "Our Product"}. We appreciate your inquiry.
  
  We are a prominent manufacturer specializing in corporate branding and promotional articles.  Our extensive 9000 sq feet facility is equipped with cutting-edge laser and UV printing machinery, ensuring precision and quality in every project.
  
  Our skilled workforce is dedicated to providing unparalleled service to meet your specific requirements. We look forward to the opportunity to collaborate with you and deliver exceptional results. 
  
  Please visit the below link to see our complete catalog
  Link :http://bit.ly/407R40S
  
  Visit our website for more info - www.printverseindia.in
  
  Best Regards,
  ${systemUsers?.find(item => item._id.toString() === record.POC?.toString())?.name ?? "Team Printverse"}
  7036231237
  Printverse Pvt Ltd.
  
  You can also connect with Mr. Prashal Agrawal (Director - Sales) on 7036231237.
  
  Feel free to reach out if you have any more questions!`
    );
  

    const whatsappURL = `https://wa.me/+91${secondary ? record.secondaryPhone : record.primaryPhone}?text=${message}`;
    window.open(whatsappURL, "_blank");
  };

  const handleAbout = async () => {
    if (!about.trim()) {
      message.warning('Comment cannot be empty');
      return;
    }

    if (!improvement.trim()) {
      message.warning('Comment cannot be empty');
      return;
    }

    try {
      const commentPayload = {
        date: new Date(),
        text: newComment
      };

      // If editing existing lead, update comments
      if (currentLead) {
        const updatedLead = {
          ...currentLead,
           platform : "CRM",
          about:about,
          requirements:improvement,
          otherProducts:otherProducts,
          secondaryPhone:secondaryPhone
        };

        await axios.post(`${constants.DOMAIN}/api/v1/marketing/createOrUpdateUser`, updatedLead);
        
        // Update local state
        setCurrentLead(updatedLead);
        setLeads(leads.map(lead => 
          lead._id === currentLead._id ? updatedLead : lead
        ));
        
        // Clear comment input
        setNewComment('');
        message.success('Details added successfully');
      } else {
        // For new lead, store comment to be saved with lead
        form.setFieldsValue({
          comments: [...(form.getFieldValue('comments') || []), commentPayload]
        });
        setNewComment('');
      }
    } catch (error) {
      message.error('Failed to add comment');
    }
  };

console.log(otherProducts);

const renderStatus = (_, record) => {

  if (record.leadType === "CONVERTED")
    return (
      <CheckOutlined
        twoToneColor="lightgreen"
        style={{ color: "lightGreen", fontSize: "25px" }}
      />
    )

  // if (record.new) {
  //   if (record.oldUser) {
  //     return (
  //       <>
  //         <Badge color="blue" />
  //         <Tooltip title="Repeating user :)">
  //           <StarFilled style={{ color: "green" }} />
  //         </Tooltip>
  //       </>
  //     )
  //   } else {
  //     return <Badge color="blue" />
  //   }
  // }
if(record.transfer){
  return        <Tooltip title="Transferred">
  <FastForwardOutlined style={{ color: "green", fontSize: "24px" }} />
</Tooltip>
}
  if (
    record.nextFollowUp &&
    new Date(record.nextFollowUp).toLocaleDateString() ===
    new Date().toLocaleDateString()
  )
    return (
      <ClockCircleTwoTone
        twoToneColor="orange"
        style={{ fontSize: "25px" }}
      />
    )
}

  // Enhanced table columns with responsive considerations
  const columns = [
    
    // ... (previous columns remain the same, but with responsive widths)
    
    {
      title: "",
      width: 50,
      render: (_, record) => {
        return <Space>{renderStatus(_, record)}</Space>
      },
    },
     isAdmin || bucket===6 ? {
      title: "POC",
      dataIndex: "POC",
      filterMultiple: false,
      width:80,
      filters: (systemUsers || []).map((d) => ({
        value: d._id,
        text: d.name,
      })),
      render: (data, record,index) => {
        return (
          <>

          {isEditing === `POC_${index}` ? <Select
            size="small"
            autoFocus
            open={true}
            // onDropdownVisibleChange={true}
            defaultValue={systemUsers?.find(item => item._id.toString() === data?.toString())?.name}
            style={{ width: '100%', minWidth: 100 }}
            onChange={(e) => {              
              record.POC = e;
            }}
            options={(systemUsers || []).map((d) => ({
              value: d._id,
              label: d.name,
            }))}
          /> : <p className='cursor-pointer' onClick={()=>{
            setEditing(`POC_${index}`)
          }}>{systemUsers?.find(item => item._id.toString() === data?.toString())?.name}</p>}
          </>
        );
      },
      responsive: ['md'],
    }:{
      width:0
    },
    bucket ===3  ? {
      title: "Transferred To",
      dataIndex: "transferredPOC",
      filterMultiple: false,
      width:150,
      filters: (systemUsers || []).map((d) => ({
        value: d._id,
        text: d.name,
      })),
      render: (data, record,index) => {
        return (
          <>

          {isEditing === `POC_${index}` ? <Select
            size="small"
            autoFocus
            open={true}
            // onDropdownVisibleChange={true}
            defaultValue={systemUsers?.find(item => item._id.toString() === data?.toString())?.name}
            style={{ width: '100%', minWidth: 100 }}
            onChange={(e) => {              
              record.POC = e;
            }}
            options={(systemUsers || []).map((d) => ({
              value: d._id,
              label: d.name,
            }))}
          /> : <p className='cursor-pointer' onClick={()=>{
            setEditing(`POC_${index}`)
          }}>{systemUsers?.find(item => item._id.toString() === data?.toString())?.name}</p>}
          </>
        );
      },
      responsive: ['md'],
    }:{
      width:0
    },
    {
      title: "Lead Type",
      dataIndex: "leadType",
      filterMultiple: false,
      width: 120,
      filters: [
        { text: "Not Answered", value: "NOT_ANSWERED" },
        { text: "Follow Up", value: "FOLLOW_UP" },
        { text: "Major Prospect", value: "MAJOR_PROSPECT" },
        { text: "Future Prospects", value: "FUTURE_PROSPECTS" },
        { text: "Closed", value: "CLOSED" },
        { text: "Closed RNR", value: "CLOSED_RNR" },
        { text: "Closed Lost", value: "CLOSED_LOST" },
        { text: "RNR Open", value: "RNR_OPEN" },
        { text: "Duplicate", value: "DUPLICATE" },
        { text: "Irrelevant", value: "IRRELEVANT" },
        { text: "Order Confirmed", value: "ORDER_CONFIRMED" },
        { text: "Sample Kit", value: 'SAMPLE_KIT' },
        { text: "Not Enquired", value: 'NOT_ENQUIRED' }
      ],
      render: (leadType, record, index) => {
        const options = [
          { value: "NOT_ANSWERED", label: "Not Answered" },
          { label: "Not Enquired", value: 'NOT_ENQUIRED' },
          { value: "FOLLOW_UP", label: "Follow Up" },
          { value: "MAJOR_PROSPECT", label: "Major Prospect" },
          { value: "FUTURE_PROSPECTS", label: "Future Prospects" },
          { value: "CLOSED", label: "Closed" },
          { value: "CLOSED_RNR", label: "Closed RNR" },
          { value: "CLOSED_LOST", label: "Closed Lost" },
          { value: "RNR_OPEN", label: "RNR Open" },
          { value: "DUPLICATE", label: "Duplicate" },
          { value: "IRRELEVANT", label: "Irrelevant" },
          { value: "ORDER_CONFIRMED", label: "Order Confirmed" },
          { label: "Sample Kit", value: 'SAMPLE_KIT' },
        
        ];
        const toTitleCase = (str) => {
          if (!str) return "No Status"; // Handle empty or undefined values
          return str
            .toLowerCase()
            .replace(/_/g, " ") // Replace underscores with spaces
            .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize the first letter of each word
        };
        
        return (
          <>
            {isEditing === `Lead_${index}` ? (
              <Select
                size="small"
                defaultValue={leadType || ""}
                style={{
                  width: 150,
                  color: LEAD_TYPE_COLORS[leadType] || "white",
                }}
                onChange={(e) => {
                  if (e === "ORDER_CONFIRMED") {
                    setIsConversionModalOpen(true);
                    // Pre-fill some values from the current lead
                    setHideSave(`Save_${index}`)
                    conversionForm.setFieldsValue({
                      primaryPhone: record.primaryPhone,
                      productCode: record?.productId,
                      poc: record?.POC,
                      city: record?.city,
                      name: record?.name,
                    });
                  }else{
                    setHideSave(false)
                  }
                  setCurrentLead(record);
                  record.leadType = e;
                }}
                options={options}
              />
            ) : (
              <p
                className="cursor-pointer"
                onClick={() => {
                  setEditing(`Lead_${index}`);
                }}
              >
                {toTitleCase(leadType) ?? "No Status"}
              </p>
            )}
          </>
        );
      },
    },
    
    {
      title: 'Source',
      dataIndex: 'source',
      key: 'source',
      filterMultiple: false,
      width:120,
      filters: (source || []).map((d) => ({
        value: d,
        text: d,
      })),
    },
    {
      title: "DOR",
      dataIndex: "createdAt",
      sorter: false,
      width:80,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <RangePicker
            showTime={{ format: 'HH:mm' }}
            format="YYYY-MM-DD HH:mm"
            value={selectedKeys[0] ? [selectedKeys[0], selectedKeys[1]] : []}
            onChange={([from, to]) => setSelectedKeys([from, to])}
            onOk={() => confirm()}
          />
          <Space>
            <button
              type="button"
              onClick={() => {
                setSelectedKeys([]);
                clearFilters();
              }}
              style={{ width: 90 }}
            >
              Reset
            </button>
            <button
              type="button"
              onClick={() => confirm()}
              style={{ width: 90 }}
            >
              OK
            </button>
          </Space>
        </div>
      ),
      // Customize the filter icon
      filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
      render: (date) => (
        <>
          {new Date(date).toLocaleDateString()}
          <br />
          <div style={{ color: "lightgray" }}>
            {new Date(date).toLocaleTimeString()}
          </div>
        </>
      ),
    },   
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      width:110,
      render: (data, record,index) => {
        return (
          <>
  {isEditing === `Name_${index}` ? (
    <Input
      defaultValue={data}
      onChange={(e) => {
        console.log(e.target.value);
        record.name = e.target.value;
      }}
    />
  ) : (
    <p
      className="cursor-pointer"
      onClick={() => {
        setEditing(`Name_${index}`);
      }}
    >
      {data}
    </p>
  )}
</>
        )
      },
      ...getColumnSearchProps('name')
    },
    {
      title: 'Company',
      dataIndex: 'company',
      key: 'company',
      width:110,
      render: (data, record,index) => {
        return (
          <>
          {isEditing === `Company_${index}` ?<Input
            defaultValue={data}
            onChange={(e) => {
              console.log(e.target.value)
              // setOldRecord(record)
              record.company = e.target.value
            }}/>:
          <p className='cursor-pointer'
           onClick={()=>{setEditing(`Company_${index}`)}}
           >{data ?? 'N/A'}</p>}
          </>
        )
      },
      ...getColumnSearchProps('company')
    },
    {
      title: 'Primary Phone',
      dataIndex: 'primaryPhone',
      key: 'primaryPhone',
      width:140,
      ...getColumnSearchProps('primaryPhone'),
      render: (data, record,index) => {
        return (
         /* {isEditing === `Phone_${index}` ?<Input
            // value={comments}
            defaultValue={data}
            onChange={(e) => {
              console.log(e.target.value)
              // setOldRecord(record)
              record.primaryPhone = e.target.value
            }} */
          // />:
          <>
          <p className='cursor-pointer'
          //  onClick={()=>{setEditing(`Phone_${index}`)}}
           ><Text copyable>{data}</Text></p>
          {record.secondaryPhone && <p className='text-gray-400 text-[12px] cursor-pointer' onClick={()=>{
            handleWhatsAppSend(record,true)
            navigator.clipboard.writeText(record.secondaryPhone)
          }}>Secondary Phone : {record.secondaryPhone}</p>}
           </>
          //  }
          // </>
        )
      },
    },
    {
      title: 'City',
      dataIndex: 'city',
      key: 'city',
      width:110,
      render: (data, record,index) => {
        return (
          <>
          {isEditing === `City_${index}` ?<Input
            // value={comments}
            defaultValue={data}
            onChange={(e) => {
              console.log(e.target.value)
              // setOldRecord(record)
              record.city = e.target.value
            }}
          />:
          <p className='cursor-pointer' onClick={()=>{setEditing(`City_${index}`)}}>{data}</p>}
          </>
        )
      },
      ...getColumnSearchProps('city')
    },
    {
      title: 'Product',
      dataIndex: 'productId',
      width:90,
      filters: (products || []).map((d) => ({
        value: d.code,
        text: d.name,
      })),
      key: 'productId',
        render: (data, record,index) => {
          const predefinedColors = [
            "magenta", "volcano", "orange", 
            "gold", "lime", "green", "cyan", 
            "blue", "geekblue", "purple"
          ];
          
          const randomColor = () => {
            return predefinedColors[Math.floor(Math.random() * predefinedColors.length)];
          };
        return (
          <>
          {isEditing === `Product_${index}` ?
          <Select
            size="small"
            defaultValue={products?.find(item => item.code === data)?.name}
            style={{ width: 150 }}
            onChange={(e) => {
              record.productId = e
              console.log(record)
            }}
            options={(products || []).map((d) => ({
              value: d.code,
              label: d?.name,
            }))}
          />:<p className='cursor-pointer' onClick={()=>{setEditing(`Product_${index}`)}}><Tooltip title={record.about} ><Tag color={products?.find(item => item.code === data)?.name ? randomColor() :'red'} className='h-6 w-fit text-center font-bold text-white'>{products?.find(item => item.code === data)?.name ?? "Other Product"}</Tag></Tooltip></p>}
          </> 
        )
      },
    },
    {
      title: "Call Details",
      dataIndex: "comments",
      sorter: false,
      width: "200",
      render: (comments, record) => {
        return (
          <>
          {comments && comments.length > 0 ? <div className='flex gap-2 items-start'>
            <Tooltip title={<div className='text-white py-2 px-4'>
              {comments && comments.length > 0 ? (
                <Timeline>
                  {comments.map((comment, index) => (
                    <Timeline.Item key={index}>
                      <div className='text-white'>
                        <strong>{dayjs(comment.date).format('DD-MM-YYYY HH:mm')}</strong>
                        <p>{comment.text}</p>
                      </div>
                    </Timeline.Item>
                  ))}
                </Timeline>
              ) : (
                <p className="text-center text-gray-500">No comments yet</p>
              )}
              </div>}>
             <InfoCircleOutlined className='w-4 h-4' onClick={()=>{
              setCurrentLead(record);
              setIsDrawerOpen(true);
              setActiveTab('comments');
             }}/></Tooltip>
             <div className='w-[400px] text-wrap'>
             {comments[comments.length -1]?.text} 
             <br></br>
             <p className='text-sm text-gray-400'>{new Date(comments[comments.length -1]?.date).toLocaleDateString()}</p>
             </div>
          </div>:<Tag className='cursor-pointer' onClick={()=>{ setCurrentLead(record);
              setIsDrawerOpen(true);
              setActiveTab('comments');}} > N/A</Tag> }
          </>
        );
      },
    },
    {
      title: "Follow up",
      dataIndex: "nextFollowUp",
      filterMultiple: false,
      sorter: false,
      fixed: "right",
      width: 110,
      filters: (followUp || []).map((d) => ({
        value: d,
        text: d,
      })),
      render: (nextFollowUp, record, index) => {
        return (
          <>
            {isEditing === `Next_${index}` ? (
              <Tooltip title="Edit Next Follow-Up">
                <DatePicker
                  size="small"
                  onChange={(v) => {
                    if (!v) return;
                    record.nextFollowUp = v.valueOf();
                  }}
                  defaultValue={nextFollowUp ? dayjs(nextFollowUp) : null}
                />
              </Tooltip>
            ) : (
              <p 
                className="cursor-pointer text-center" 
                onClick={() => setEditing(`Next_${index}`)}
              >
                {nextFollowUp ? dayjs(nextFollowUp).format('DD-MMM-YYYY') : <Tag />}
              </p>
            )}
          </>
        );
      },
    },
    {
      title: 'Actions',
      key: 'actions',
      fixed: "right",
      width: 100,
      render: (text, record,index) => (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '5px' }}>
         { hideSave !== `Save_${index}` && <Tooltip title="Edit">
            <Button 
              icon={<EditOutlined style={{ color: "blue" }}/>} 
              onClick={() => {
                setCurrentLead(record);
                handleSubmit(record);
              }}
            />
          </Tooltip>}
          <Tooltip title="History">
            <Button 
              icon={<HistoryOutlined style={{ color: "red" }} />} 
              onClick={() => {
                setCurrentLead(record);
                fetchActivity(record._id)
                setIsDrawerOpen(true);
                setActiveTab('preview');
              }}
            />
          </Tooltip>
          <Tooltip title="Comments">
            <Button 
              icon={<CommentOutlined style={{ color: "green" }}/>} 
              onClick={() => {
                setCurrentLead(record);
                setIsDrawerOpen(true);
                setActiveTab('comments');
              }}
            />
          </Tooltip>
          <Tooltip title="Transfer">
            <Button 
              icon={<TransactionOutlined style={{ color: "purple" }}/>} 
              onClick={() => {
                setCurrentLead(record);
                setIsTransferModalOpen(true)
              }}
            />
          </Tooltip>
          <Tooltip title="About">
            <Button 
              icon={<FileTextOutlined style={{ color: "orange" }}/>} 
              onClick={() => {
                setCurrentLead(record);
                setAbout(record.about);
                setOtherProducts(record.otherProducts)
                setImprovement(record.requirements);
                setSecondaryPhone(record.secondaryPhone)
                setIsDrawerOpen(true);
                setActiveTab('about');
              }}
            />
          </Tooltip>
          <Tooltip title="WhatsApp">
            <Button 
              icon={<WhatsAppOutlined  style={{ color: "green" }}/>} 
              onClick={()=>{
                handleWhatsAppSend(record)
              }}
            />
          </Tooltip>
          <Tooltip title="Create Performa">
            <Button 
              icon={<FileOutlined  style={{ color: "green" }}/>} 
              onClick={()=>{
                setIsPerfomaModalOpen(true);
                performaModel.setFieldsValue({
                  primaryPhone: record.primaryPhone,
                  productCode: record?.productId,
                  poc: record?.POC,
                  city: record?.city,
                  name: record?.name,
                });
              }}
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  // Responsive classes for the main container
  const containerClasses = "p-2 md:p-6 bg-gray-50 min-h-screen";
  const cardClasses = "bg-white shadow-md rounded-lg p-2 md:p-6";
  const headerClasses = "flex flex-col md:flex-row justify-between items-center mb-4 md:mb-6 gap-2";

  return (
    <div className={containerClasses}>
      <ConversionModal />
      <PerfomaModel/>
      <TransferPoc />
      <div className={cardClasses}>
        <div className={headerClasses}>
          <h1 className="text-xl md:text-2xl font-bold text-gray-800">
            Lead Management
          </h1>
          <div className='flex gap-2'>
          {isAdmin&&<Button 
            type={showAdmin === "true" ? "primary" :"dashed"} 
            icon={<ReloadOutlined />} 
            onClick={() => {
              setShowAdmin(showAdmin === "true" ? "false":"true")
            }}
          >
           Active Admin Dash
          </Button>}
          <Button 
            type='dashed'
            onClick={() => {
             setTableParams((prev)=>{
              return {...prev,filters: {}}
             })
            }}
          >
            Clear Filters
          </Button>
          <Button 
            type={viewType === "OLDER" ? "primary" :"dashed"} 
            icon={<ReloadOutlined />} 
            onClick={() => {
              setViewType(viewType === "OLDER" ? "":"OLDER")
            }}
          >
            Older Followup
          </Button>
          <Button 
            type={viewType === "FOLLOWUP" ? "primary" :"dashed"} 
            icon={<ReloadOutlined />} 
            onClick={() => {
              setViewType(viewType === "FOLLOWUP" ? "":"FOLLOWUP")
            }}
          >
            Today Followup
          </Button>
          <Button 
            type="primary" 
            icon={<PlusOutlined />} 
            onClick={() => {
              setCurrentLead(null);
              setIsDrawerOpen(true);
              setActiveTab('details');
            }}
          >
            Add New Lead
          </Button>
          </div>
        </div>



<div className="border-b border-gray-200  mb-2">
    <ul className="flex flex-wrap -mb-px text-sm font-medium text-center text-gray-500 dark:text-gray-400">
        <li className="me-2" onClick={()=>{
          setBucket(0)
        }}>
            <a href="#" className={`inline-flex items-center justify-center p-4 border-b-2  rounded-t-lg group ${bucket === 0 ? 'text-blue-600 border-b-2 border-blue-600' : 'border-transparent hover:text-gray-600 hover:border-gray-300 '}`}>
                <svg className={`w-4 h-4 me-2 ${bucket === 0 ? 'text-blue-600' : 'text-gray-400 group-hover:text-gray-500'}`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10 0a10 10 0 1 0 10 10A10.011 10.011 0 0 0 10 0Zm0 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 13a8.949 8.949 0 0 1-4.951-1.488A3.987 3.987 0 0 1 9 13h2a3.987 3.987 0 0 1 3.951 3.512A8.949 8.949 0 0 1 10 18Z"/>
                </svg>New Leads
            </a>
        </li>
        <li className="me-2" onClick={()=>{
          setBucket(7)
        }}>
            <a href="#" className={`inline-flex items-center justify-center p-4 border-b-2  rounded-t-lg group ${bucket === 7 ? 'text-blue-600 border-b-2 border-blue-600' : 'border-transparent hover:text-gray-600 hover:border-gray-300 '}`}>
                <svg className={`w-4 h-4 me-2 ${bucket === 7 ? 'text-blue-600' : 'text-gray-400 group-hover:text-gray-500'}`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10 0a10 10 0 1 0 10 10A10.011 10.011 0 0 0 10 0Zm0 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 13a8.949 8.949 0 0 1-4.951-1.488A3.987 3.987 0 0 1 9 13h2a3.987 3.987 0 0 1 3.951 3.512A8.949 8.949 0 0 1 10 18Z"/>
                </svg>Not Enquired
            </a>
        </li>
      
        <li className="me-2" onClick={()=>{
          setBucket(2)
        }}>
            <a href="#" className={`inline-flex items-center justify-center p-4 border-b-2  rounded-t-lg group ${bucket === 2 ? 'text-blue-600 border-b-2 border-blue-600' : 'border-transparent hover:text-gray-600 hover:border-gray-300 '}`}>
                <svg className={`w-4 h-4 me-2 ${bucket === 2 ? 'text-blue-600' : 'text-gray-400 group-hover:text-gray-500'}`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M5 11.424V1a1 1 0 1 0-2 0v10.424a3.228 3.228 0 0 0 0 6.152V19a1 1 0 1 0 2 0v-1.424a3.228 3.228 0 0 0 0-6.152ZM19.25 14.5A3.243 3.243 0 0 0 17 11.424V1a1 1 0 0 0-2 0v10.424a3.227 3.227 0 0 0 0 6.152V19a1 1 0 1 0 2 0v-1.424a3.243 3.243 0 0 0 2.25-3.076Zm-6-9A3.243 3.243 0 0 0 11 2.424V1a1 1 0 0 0-2 0v1.424a3.228 3.228 0 0 0 0 6.152V19a1 1 0 1 0 2 0V8.576A3.243 3.243 0 0 0 13.25 5.5Z"/>
                </svg>Follow Ups
            </a>
        </li>
        <li className="me-2" onClick={()=>{
          setBucket(8)
        }}>
            <a href="#" className={`inline-flex items-center justify-center p-4 border-b-2  rounded-t-lg group ${bucket === 8 ? 'text-blue-600 border-b-2 border-blue-600' : 'border-transparent hover:text-gray-600 hover:border-gray-300 '}`}>
                <svg className={`w-4 h-4 me-2 ${bucket === 8 ? 'text-blue-600' : 'text-gray-400 group-hover:text-gray-500'}`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M5 11.424V1a1 1 0 1 0-2 0v10.424a3.228 3.228 0 0 0 0 6.152V19a1 1 0 1 0 2 0v-1.424a3.228 3.228 0 0 0 0-6.152ZM19.25 14.5A3.243 3.243 0 0 0 17 11.424V1a1 1 0 0 0-2 0v10.424a3.227 3.227 0 0 0 0 6.152V19a1 1 0 1 0 2 0v-1.424a3.243 3.243 0 0 0 2.25-3.076Zm-6-9A3.243 3.243 0 0 0 11 2.424V1a1 1 0 0 0-2 0v1.424a3.228 3.228 0 0 0 0 6.152V19a1 1 0 1 0 2 0V8.576A3.243 3.243 0 0 0 13.25 5.5Z"/>
                </svg>RNR Open
            </a>
        </li>
        <li className="me-2" onClick={()=>{
          setBucket(3)
        }}>
            <a href="#" className={`inline-flex items-center justify-center p-4 border-b-2  rounded-t-lg group ${bucket === 3 ? 'text-blue-600 border-b-2 border-blue-600' : 'border-transparent hover:text-gray-600 hover:border-gray-300 '}`}>
                <svg className={`w-4 h-4 me-2 ${bucket === 3 ? 'text-blue-600' : 'text-gray-400 group-hover:text-gray-500'}`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 18 20">
                    <path d="M16 1h-3.278A1.992 1.992 0 0 0 11 0H7a1.993 1.993 0 0 0-1.722 1H2a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2Zm-3 14H5a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2Zm0-4H5a1 1 0 0 1 0-2h8a1 1 0 1 1 0 2Zm0-5H5a1 1 0 0 1 0-2h2V2h4v2h2a1 1 0 1 1 0 2Z"/>
                </svg>Transferred by You
            </a>
        </li>
        <li className="me-2" onClick={()=>{
          setBucket(6)
        }}>
            <a href="#" className={`inline-flex items-center justify-center p-4 border-b-2  rounded-t-lg group ${bucket === 6 ? 'text-blue-600 border-b-2 border-blue-600' : 'border-transparent hover:text-gray-600 hover:border-gray-300 '}`}>
                <svg className={`w-4 h-4 me-2 ${bucket === 6 ? 'text-blue-600' : 'text-gray-400 group-hover:text-gray-500'}`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 18 20">
                    <path d="M16 1h-3.278A1.992 1.992 0 0 0 11 0H7a1.993 1.993 0 0 0-1.722 1H2a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2Zm-3 14H5a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2Zm0-4H5a1 1 0 0 1 0-2h8a1 1 0 1 1 0 2Zm0-5H5a1 1 0 0 1 0-2h2V2h4v2h2a1 1 0 1 1 0 2Z"/>
                </svg>Transferred For You
            </a>
        </li>
        <li className="me-2" onClick={()=>{
          setBucket(1)
        }}>
            <a href="#" className={`inline-flex items-center justify-center p-4 border-b-2  rounded-t-lg group ${bucket === 1 ? 'text-blue-600 border-b-2 border-blue-600' : 'border-transparent hover:text-gray-600 hover:border-gray-300 '}`} aria-current="page">
                <svg className={`w-4 h-4 me-2 ${bucket === 1 ? 'text-blue-600' : 'text-gray-400 group-hover:text-gray-500'}`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 18 18">
                    <path d="M6.143 0H1.857A1.857 1.857 0 0 0 0 1.857v4.286C0 7.169.831 8 1.857 8h4.286A1.857 1.857 0 0 0 8 6.143V1.857A1.857 1.857 0 0 0 6.143 0Zm10 0h-4.286A1.857 1.857 0 0 0 10 1.857v4.286C10 7.169 10.831 8 11.857 8h4.286A1.857 1.857 0 0 0 18 6.143V1.857A1.857 1.857 0 0 0 16.143 0Zm-10 10H1.857A1.857 1.857 0 0 0 0 11.857v4.286C0 17.169.831 18 1.857 18h4.286A1.857 1.857 0 0 0 8 16.143v-4.286A1.857 1.857 0 0 0 6.143 10Zm10 0h-4.286A1.857 1.857 0 0 0 10 11.857v4.286c0 1.026.831 1.857 1.857 1.857h4.286A1.857 1.857 0 0 0 18 16.143v-4.286A1.857 1.857 0 0 0 16.143 10Z"/>
                </svg>Sample Kits
            </a>
        </li>
        
        <li className="me-2" onClick={()=>{
          setBucket(5)
        }}>
            <a href="#" className={`inline-flex items-center justify-center p-4 border-b-2  rounded-t-lg group ${bucket === 5 ? 'text-blue-600 border-b-2 border-blue-600' : 'border-transparent hover:text-gray-600 hover:border-gray-300 '}`}>
                <svg className={`w-4 h-4 me-2 ${bucket === 5 ? 'text-blue-600' : 'text-gray-400 group-hover:text-gray-500'}`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 18 20">
                    <path d="M16 1h-3.278A1.992 1.992 0 0 0 11 0H7a1.993 1.993 0 0 0-1.722 1H2a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2Zm-3 14H5a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2Zm0-4H5a1 1 0 0 1 0-2h8a1 1 0 1 1 0 2Zm0-5H5a1 1 0 0 1 0-2h2V2h4v2h2a1 1 0 1 1 0 2Z"/>
                </svg>Coverted
            </a>
        </li>
        <li className="me-2" onClick={()=>{
          setBucket(4)
        }}>
            <a href="#" className={`inline-flex items-center justify-center p-4 border-b-2  rounded-t-lg group ${bucket === 4 ? 'text-blue-600 border-b-2 border-blue-600' : 'border-transparent hover:text-gray-600 hover:border-gray-300 '}`}>
                <svg className={`w-4 h-4 me-2 ${bucket === 4 ? 'text-blue-600' : 'text-gray-400 group-hover:text-gray-500'}`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 18 20">
                    <path d="M16 1h-3.278A1.992 1.992 0 0 0 11 0H7a1.993 1.993 0 0 0-1.722 1H2a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2Zm-3 14H5a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2Zm0-4H5a1 1 0 0 1 0-2h8a1 1 0 1 1 0 2Zm0-5H5a1 1 0 0 1 0-2h2V2h4v2h2a1 1 0 1 1 0 2Z"/>
                </svg>Closed
            </a>
        </li>
    </ul>
</div>


        <div className="overflow-x-auto">
          <Table 
            columns={columns} 
            dataSource={leads}
            loading={{
              indicator: <LoadingOutlined style={{ fontSize: 24 }} spin />,
              spinning: isLoading
            }}
            pagination={{
              ...tableParams.pagination,
              responsive: true,
              showSizeChanger: true,
              showQuickJumper: true,
            }}
            onChange={handleTableChange}
            scroll={{ x: 'max-content' }}
            size="small"
            className="w-full"
          />
        </div>

        <Drawer
          title={currentLead ? 'Edit Lead' : 'Create New Lead'}
          width={typeof window !== 'undefined' ? window.innerWidth < 768 ? '100%' : 720 : 720}
          onClose={() => {
            setIsDrawerOpen(false);
            setCurrentLead(null);
          }}
          open={isDrawerOpen}
          placement={typeof window !== 'undefined' ? window.innerWidth < 768 ? 'bottom' : 'right' : 'right'}
          height={typeof window !== 'undefined' ? window.innerWidth < 768 ? '80vh' : 'auto' : 'auto'}
          extra={
            <Space>
              {!currentLead && <Button 
                type={activeTab === 'details' ? 'primary' : 'default'}
                onClick={() => setActiveTab('details')}
              >
                Details
              </Button>}
              <Button 
                type={activeTab === 'preview' ? 'primary' : 'default'}
                onClick={() => setActiveTab('preview')}
              >
                Preview
              </Button>
              <Button 
                type={activeTab === 'comments' ? 'primary' : 'default'}
                onClick={() => setActiveTab('comments')}
              >
                Comments
              </Button>
            </Space>
          }
        >
          {/* Drawer content remains the same but with loading states */}
          <Spin spinning={isSubmitting}>
          {activeTab === 'details' && (
            <Form
              form={form}
              layout="vertical"
              onFinish={handleSubmit}
            >
              <Form.Item
                name="name"
                label="Name"
                rules={[{ required: true, message: 'Please enter name' }]}
              >
                <Input placeholder="Enter lead name" />
              </Form.Item>

              <Form.Item
                name="city"
                label="City"
                // rules={[{ required: true, message: 'Please enter City' }]}
              >
                <Input placeholder="Enter lead City" />
              </Form.Item>

              <Form.Item
                name="email"
                label="Email"
                rules={[
                
                  { type: 'email', message: 'Please enter a valid email' }
                ]}
              >
                <Input placeholder="Enter lead email" />
              </Form.Item>

              <Form.Item
                name="primaryPhone"
                label="Primary Phone"
                rules={[{ required: true, message: 'Please enter primary phone' }]}
              >
                <Input placeholder="Enter primary phone number" />
              </Form.Item>

              <Form.Item name="secondaryPhone" label="Secondary Phone">
                <Input placeholder="Enter secondary phone number" />
              </Form.Item>

             {isAdmin && <Form.Item
                name="POC"
                label="Point of Contact"
                rules={[{ required: true, message: 'Please POC' }]}
              >
                <Select 
                  placeholder="Select POC"
                  allowClear
                >
                  {systemUsers.map(user => (
                    <Option key={user._id} value={user._id}>
                      {user.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>}

              <Form.Item
                name="productId"
                label="Product"
                rules={[{ required: true, message: 'Please Select Product' }]}
              >
                <Select 
                  placeholder="Select Product"
                  allowClear
                >
                  {products.map(user => (
                    <Option key={user.code} value={user.code}>
                      {user.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                name="nextFollowUp"
                label="Next Follow Up Date"
              >
                <DatePicker 
                  className="w-full" 
                  placeholder="Select next follow up date" 
                />
              </Form.Item>

              <Form.Item
                name="source"
                label="Source"
                rules={[{ required: true, message: 'Please enter Source' }]}
              >
                <Input placeholder="Enter lead source" />
              </Form.Item>

              <Form.Item>
                <Button 
                  type="primary" 
                  htmlType="submit" 
                  block
                >
                  {currentLead ? 'Update Lead' : 'Create Lead'}
                </Button>
              </Form.Item>
            </Form>
          )}

          {/* Preview Tab */}
          {activeTab === 'preview' && currentLead && (
            <div className="p-4">
              <h2 className="text-xl font-bold mb-4">Activity Log</h2>
              <div className="grid grid-cols-2 gap-4">
                {/* <div>
                  <strong>Name:</strong> {currentLead.name}
                </div>
                <div>
                  <strong>Email:</strong> {currentLead.email}
                </div>
                <div>
                  <strong>Primary Phone:</strong> {currentLead.primaryPhone}
                </div>
                <div>
                  <strong>Secondary Phone:</strong> {currentLead.secondaryPhone || 'N/A'}
                </div>
                <div>
                  <strong>Lead Type:</strong> 
                  <Tag color={LEAD_TYPE_COLORS[currentLead.leadType]}>
                    {currentLead.leadType}
                  </Tag>
                </div>
                <div>
                  <strong>Point of Contact:</strong> 
                  {currentLead.POC?.name || 'Not assigned'}
                </div>
                <div>
                  <strong>Next Follow Up:</strong> 
                  {currentLead.nextFollowUp 
                    ? dayjs(currentLead.nextFollowUp).format('DD-MM-YYYY') 
                    : 'Not scheduled'}
                </div>
                <div>
                  <strong>Source:</strong> {currentLead.source || 'N/A'}
                </div> */}
                {activity && activity.length > 0 ? (
                <div className='flex flex-col gap-5 mt-5'>
                  {/* <p className='font-bold'>Activity Log</p> */}
                <Timeline>
                  {activity.map((comment, index) => (
                    <Timeline.Item key={index}>
                      <div>
                        <strong>{dayjs(comment.date).format('DD-MM-YYYY HH:mm')}</strong>
                        <p>{comment.description}</p>
                      </div>
                    </Timeline.Item>
                  ))}
                </Timeline>
                </div>
              ) : (
                <p className="text-center text-gray-500">No Activity yet</p>
              )}
              </div>
            </div>
          )}

          {/* Comments Tab */}
          {activeTab === 'comments' && (
            <div className="p-4">
              <div className="mb-4">
                <TextArea 
                  rows={4} 
                  value={newComment}
                  onChange={(e) => setNewComment(e.target.value)}
                  placeholder="Add a comment..."
                />
                <Button 
                  type="primary" 
                  icon={<CommentOutlined />}
                  onClick={handleAddComment}
                  className="mt-2"
                >
                  Add Comment
                </Button>
              </div>

              {currentLead && currentLead.comments && currentLead.comments.length > 0 ? (
                <Timeline>
                  {currentLead.comments.map((comment, index) => (
                    <Timeline.Item key={index}>
                      <div>
                        <strong>{dayjs(comment.date).format('DD-MM-YYYY HH:mm')}</strong>
                        <p>{comment.text}</p>
                      </div>
                    </Timeline.Item>
                  ))}
                </Timeline>
              ) : (
                <p className="text-center text-gray-500">No comments yet</p>
              )}
            </div>
          )}
           {activeTab === 'about' && (
            <div className="p-4 ">
              <div className="mb-4 flex flex-col gap-5">
                <div>
                 <p className='font-bold'>About</p>
                <TextArea 
                  rows={4} 
                  value={about}
                  onChange={(e) => setAbout(e.target.value)}
                  placeholder="Add a About..."
                />
                </div>
                <div>
                 <p className='font-bold'>Requirements</p>
                <TextArea 
                  rows={4} 
                  value={improvement}
                  onChange={(e) => setImprovement(e.target.value)}
                  placeholder="Add a Requirement..."
                />
                 </div>
                 <div>
                 <p className='font-bold'>Additional Products</p>
            <Select mode="multiple" placeholder="Select Products" className='min-w-40' value={otherProducts} onChange={(e)=>{
              setOtherProducts(e)
            }}>
            {products.map(user => (
                    <Option key={user.code} value={user.code}>
                      {user.name}
                    </Option>
                  ))}
            </Select>
         
                 </div>
                 <div>
                 <p className='font-bold'>Secondary Phone</p>
                <Input 
                  rows={4} 
                  value={secondaryPhone}
                  onChange={(e) => setSecondaryPhone(e.target.value)}
                  placeholder="Add a phone..."
                />
                </div>
                <Button 
                  type="primary" 
                  icon={<CommentOutlined />}
                  onClick={handleAbout}
                  className="mt-2 w-fit"
                >
                  Save
                </Button>
              </div>
            </div>
          )}
          </Spin>
        </Drawer>
      </div>
    </div>
  );
};

export default LeadManagement;

//redeploy
